import React from "react";
import { CustomInput, Row } from "taltech-styleguide";
import { ParametersTable } from "./ParametersTable";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTooltip } from "./OverlayTooltip";

export const LayoutInfoComponent: React.FC<{ data: any }> = ({ data }) => {
  return (
    <div className="build-spec-section">
      <div className="section-header">
        <h5>Layout</h5>
      </div>
      <div className="section-body">
        <Row className="mb-1">
          <label>
            <span>Row 1</span>
          </label>
        </Row>
        <Row className="mt-0">
          <label>
            <span>No. of Rooms:</span>
            {data.rowFirst.numberOfRooms}
          </label>
          <div className="w-12">
            <table className="rooms-table">
              <tr>
                <th>Number</th>
                <th>Width</th>
                <th>Length</th>
                <th>Space Function</th>
                <th>Variable</th>
              </tr>
              {data.rowFirst.rooms.map((room: any) => (
                <tr key={room.number}>
                  <td>{room.number}</td>
                  <td>{room.width}</td>
                  <td>{room.length}</td>
                  <td>
                    <OverlayTooltip
                      data={{
                        creationType: room.isVariableLength
                          ? "RANDOM"
                          : "FIXED",
                        parameters: room.spaceFunction.parameters,
                      }}
                      component={DynamicTooltip}
                    >
                      <span>{room.spaceFunction.name}</span>
                    </OverlayTooltip>
                  </td>
                  <td>
                    <CustomInput
                      type="radio"
                      checked={room.isVariableLength === true}
                    />
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Row>
        <Row className="mt-5 mb-1">
          <label>
            <span>Row 2</span>
          </label>
        </Row>
        <Row className="mt-0">
          <label>
            <span>No. of Rooms:</span>
            {data.rowSecond.numberOfRooms}
          </label>
          <div className="w-12">
            <table className="rooms-table">
              <tr>
                <th>Number</th>
                <th>Width</th>
                <th>Length</th>
                <th>Space Function</th>
                <th>Variable</th>
              </tr>
              {data.rowSecond.rooms.map((room: any) => (
                <tr key={room.number}>
                  <td>{room.number}</td>
                  <td>{room.width}</td>
                  <td>{room.length}</td>
                  <td>
                    <OverlayTooltip
                      data={{
                        creationType: room.isVariableLength
                          ? "RANDOM"
                          : "FIXED",
                        parameters: room.spaceFunction.parameters,
                      }}
                      component={DynamicTooltip}
                    >
                      <span>{room.spaceFunction.name}</span>
                    </OverlayTooltip>
                  </td>
                  <td>
                    <CustomInput
                      type="radio"
                      checked={room.isVariableLength === true}
                    />
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Row>
      </div>
    </div>
  );
};

const DynamicTooltip = ({ creationType, parameters }: any) => (
  <Tooltip style={{ position: "fixed" }}>
    <ParametersTable
      creationType={creationType}
      parameters={parameters}
    ></ParametersTable>
  </Tooltip>
);
